// extracted by mini-css-extract-plugin
export default {"wrapper":"wSegpGnB_fm8hLw4KGXN"};